module.exports = __webpack_public_path__ + "img/Paladin-bloodelf-f-70.2df6a69e.gif";